__webpack_require__.p = "/SpiritStones/";